import { ReactNode } from 'react';

interface FormEntryProps {
  label: string;
  children: ReactNode;
}

export default function FormEntry({ label, children }: FormEntryProps): JSX.Element {
  return (
    <>
      <label className="cr-font-main cr-font-medium cr-ml-4 cr-mr-4 cr-mt-1 cr-text-[16px]">{label}</label>
      <div className="cr-m-2 cr-font-main cr-text-[16px]">{children}</div>
    </>
  );
}
